<div class="u-flex-full">
  <label>{{value?.user?.fullName}} </label>
  <button class="close" *ngIf="value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearProfessional()">
    <mat-icon>close</mat-icon>
  </button>
</div>
